import React from 'react';
import {
  Box, Button, Card, CardContent, CircularProgress, IconButton, Slide, Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import PhoneIcon from '@mui/icons-material/Phone';
import CloseIcon from '@mui/icons-material/Close';
import {
  cardContentSx, loadingBoxSx, parentBoxSx, mainBoxSx, iconBtnSx, textBtnSx,
} from './styles';
import useMerchant from '../../resources/merchant/read';
import { standardizePhone } from '../../utils/phone';

const DealershipCard = ({
  selectedDealershipId,
  setSelectedDealershipId,
  confirmSelectedDealership,
}) => {
  const { data: dealerInfo = {}, isLoading } = useMerchant(selectedDealershipId);

  const {
    name,
    address1,
    city,
    state,
    zip,
    website,
    service_phone: servicePhone,
  } = dealerInfo;

  const phone = standardizePhone(servicePhone);
  const params = new URLSearchParams({
    address: address1, city, state, zip,
  }).toString();

  const renderUrl = (value) => {
    try {
      return new URL(value).origin;
    } catch {
      return value;
    }
  };

  return (
    <Slide direction="up" in mountOnEnter unmountOnExit timeout={500}>
      <Card>
        <CardContent sx={cardContentSx}>
          {isLoading
            ? (
              <Box sx={loadingBoxSx}>
                <CircularProgress />
              </Box>
            )
            : (
              <Box sx={parentBoxSx}>
                <Box sx={mainBoxSx}>
                  <Typography variant="h2">{name}</Typography>
                  <IconButton
                    onClick={() => setSelectedDealershipId(null)}
                    sx={iconBtnSx}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Button
                  target="_blank"
                  href={`https://www.google.com/maps/dir/?api=1&destination=${params}`}
                  variant="text"
                  size="small"
                  sx={textBtnSx}
                >
                  {address1}
                  <br />
                  {city}
                  ,
                  {' '}
                  {state}
                  {' '}
                  {zip}
                </Button>
                {website
                  && (
                  <Button
                    target="_blank"
                    href={website}
                    variant="text"
                    size="small"
                    startIcon={<LanguageIcon />}
                    sx={textBtnSx}
                  >
                    {renderUrl(website)}
                  </Button>
                  )}
                {servicePhone
                  && (
                  <Button
                    href={`tel:${phone.normalized}`}
                    variant="text"
                    size="small"
                    startIcon={<PhoneIcon />}
                    sx={textBtnSx}
                  >
                    {phone.formatted}
                  </Button>
                  )}
                {confirmSelectedDealership
                  ? (
                    <Button
                      fullWidth
                      onClick={() => confirmSelectedDealership(selectedDealershipId)}
                      sx={{ mt: '24px', mb: '16px' }}
                    >
                      Select This Location
                    </Button>
                  )
                  : (
                    <Button
                      fullWidth
                      href={`/${process.env.PREFIX}/apply?merchantId=${selectedDealershipId}&utm_source=repair-finder`}
                      sx={{ mt: '24px', mb: '16px' }}
                    >
                      Prequalify Now
                    </Button>
                  )}
              </Box>
            )}
        </CardContent>
      </Card>
    </Slide>
  );
};

export default DealershipCard;
